// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.stayed-details-section {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.stayed-details-section .section-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
  padding: 0;
  color: var(--ceoTrackTitleColor);
  user-select: none;
}

.stayed-info-container {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stayed-details-section .NoticeDetailRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stayed-details-section .NoticeDetailRow dt {
  font-weight: 400;
  color: var(--tooltipBackgroundColor);
  min-width: 200px;
  margin: 0;
}

.stayed-details-section .NoticeDetailRow dd {
  margin: 0;
  color: var(--ceoTrackTitleColor);
  font-weight: 400;
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/components/StayedDetailsSection/StayedDetailsSection.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,OAAO;AACT","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.stayed-details-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.stayed-details-section .section-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n  padding: 0;\n  color: var(--ceoTrackTitleColor);\n  user-select: none;\n}\n\n.stayed-info-container {\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.stayed-details-section .NoticeDetailRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.stayed-details-section .NoticeDetailRow dt {\n  font-weight: 400;\n  color: var(--tooltipBackgroundColor);\n  min-width: 200px;\n  margin: 0;\n}\n\n.stayed-details-section .NoticeDetailRow dd {\n  margin: 0;\n  color: var(--ceoTrackTitleColor);\n  font-weight: 400;\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
